<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        <strong>创建</strong> 角色
      </div>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-form-group label="角色名" label-for="name">
          <b-form-input id="name" type="text" v-model="data.name"
              required :disabled="isUpdate"></b-form-input>
        </b-form-group>
        <b-form-group label="权限" label-for="mask">
        <b-form-checkbox-group name="mask" v-model="data.mask"
                               :options="getAuthOptions(data.mask)">
        </b-form-checkbox-group>
        </b-form-group>
        <div slot="footer">
          <b-button type="submit" size="sm" variant="outline-primary"><i class="fa fa-check"></i> 提交</b-button>
          <b-button type="reset" size="sm" variant="outline-secondary"><i class="fa fa-remove"></i> 返回</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import utils from '@/utils/utils'

export default {
  name: 'role-create',
  mixins: [Error],
  data () {
    return {
      data: {
        name: '',
        mask: ''
      }
    }
  },
  computed: {
    isUpdate: function () {
      // eslint-disable-next-line
      return this.$route.params.id ? true : false
    }
  },
  created () {
    if (this.isUpdate) {
      this.fetchData()
    }
  },
  methods: {
    fetchData () {
      this.$ajax.get(api.getRoleDetail(this.$route.params.id)).then((roleData) => {
        roleData.role_info.mask = utils.maskToArray(roleData.role_info.mask)
        this.data = roleData.role_info
      }, (res) => {
        this.handleError(res)
      })
    },
    getAuthOptions (authMask) {
      return utils.getAuthOptions(authMask)
    },
    onSubmit (evt) {
      evt.preventDefault()
      let updateData = utils.copyObject(this.data)
      updateData.mask = utils.arrayToMask(updateData.mask)
      if (this.isUpdate) {
        api.updateData(this, api.getRoleDetail(this.$route.params.id), updateData)
      } else {
        api.createData(this, api.getRoleCreate(), updateData, 'role-list')
      }
    },
    onReset (evt) {
      this.$router.go(-1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// RoleUpdate.vue?7f8d5496